<script lang="ts">
export default {
  name: 'KkDateRangeSelect'
}
</script>

<script lang="ts" setup>
import moment from 'moment'
import {computed} from 'vue'

defineProps<{
  loading: boolean,
  selectedYear: number,
  selectedMonth: number,
  selectedPeriod: number,
  ranges: number[]
}>()
const years = computed(() => {
  const thisYear = moment().year()
  const arr = []
  for (let i = 0; i < 3; i++) {
    arr.push({
      key: thisYear - i + '年',
      value: thisYear - i,
    })
  }
  return arr
})
const months = computed(() => {
  const arr = []
  for (let i = 1; i <= 12; i++) {
    arr.push({
      key: i + '月',
      value: i,
    })
  }
  return arr
})
const emit = defineEmits({
  'on-date-range-changed': (payload: { value: number, type: 'year' | 'month' | 'period' }) => true,
})
const handleChangePeriod = (event: Event) => {
  emit('on-date-range-changed', { value: Number((event.target as HTMLSelectElement).value), type: 'period' })
}
const handleChangeMonth = (event: Event) => {
  emit('on-date-range-changed', { value: Number((event.target as HTMLSelectElement).value), type: 'month' })
}
const handleChangeYear = (event: Event) => {
  emit('on-date-range-changed', { value: Number((event.target as HTMLSelectElement).value), type: 'year' })
}
</script>

<template>
  <div class="dateRangeSelect">
    <div class="dateRangeSelect__date">
      <div class="c-select dateRangeSelect__select">
        <select :value="selectedYear"
                :disabled="loading"
                @change="handleChangeYear"
        >
          <option v-for="year in years" :key="'year_' + year.key" :value="year.value">
            {{ year.key }}
          </option>
        </select>
      </div>
      <div class="c-select dateRangeSelect__select">
        <select :value="selectedMonth"
                :disabled="loading"
                @change="handleChangeMonth"
        >
          <option v-for="month in months" :key="'month_' + month.key" :value="month.value">
            {{ month.key }}
          </option>
        </select>
      </div>
      <div class="">
        {{ $t('pages.companies.analysis.qscas.until') }}
      </div>
    </div>
    <div class="c-select dateRangeSelect__select">
      <select :value="selectedPeriod"
              :disabled="loading"
              @change="handleChangePeriod"
      >
        <option v-for="val in ranges" :key="'period_' + val" :value="val">
          {{ $t('pages.companies.analysis.qscas.period', { number: val }) }}
        </option>
      </select>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../../stylesheets/biz_spa/foundation/var";
@import "../../../../../../stylesheets/biz_spa/foundation/mixin";
.dateRangeSelect {
  &__date {
    display: flex;
    gap: 0 16px;
    align-items: center;
    margin-bottom: 16px;
  }
  &__select {
    margin-top: 0;
  }
  @include mq(md) {
    display: flex;
    gap: 0 16px;
    align-items: center;
    &__date {
      margin-bottom: 0;
    }
  }
}
</style>
